import { config } from '../../config';
import { trace } from './trace';
import * as storage from '../login/storage';
import { reportErrorToSentry } from './sentry';
import type { UserManager } from 'oidc-client-ts';

const saveCurrentRoute = () => {
    const initialRoute = window.location.hash.replace(/^#\/?/u, '');
    storage.routeStorage.saveRoute(initialRoute);
    trace('saving initial route', initialRoute);
};

const doSignIn = (userManager: UserManager, isAuthCodeRedirect: boolean) =>
    isAuthCodeRedirect ? userManager.signinCallback() : userManager.signinSilent();

export const attemptInitialSignIn = async (userManager: UserManager) => {
    const isAuthCodeRedirect =
        window.location.href.startsWith(config.login.redirectUri as string) &&
        /[?&]code=[^&]*/.test(window.location.search);

    try {
        const user = await doSignIn(userManager, isAuthCodeRedirect);
        const initialRoute = storage.routeStorage.getRoute();

        trace('initialRoute lookup', initialRoute);

        if (initialRoute && isAuthCodeRedirect) {
            trace(`Go to location "/${initialRoute}"`);
            window.location.replace(`${window.location.origin}/#/${initialRoute}`);
        } else if (isAuthCodeRedirect) {
            window.location.replace(window.location.origin);
        }

        storage.routeStorage.discardRoute();
        return user;
    } catch (error) {
        trace('oidc.signinSilent failed, trying page redirect...', error);

        if (config.login.preventRedirect) {
            console.warn('[feature/login] redirect prevented due to config. Error was', error);
        } else if (isAuthCodeRedirect) {
            trace('oidc.signinSilent.error', 'redirect prevented due to suspicious signin error', error);
            storage.routeStorage.discardRoute();
            reportErrorToSentry(error);
        } else {
            saveCurrentRoute();
            await userManager.signinRedirect({
                extraQueryParams: {
                    idp: 'azure-my-rio-de',
                },
            });
            return undefined;
        }

        trace('auth problem?', error);
        throw new Error('Need to sign in');
    }
};
